/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { ClFarmAlmType } from "@/domains/core"

import { simulatedTransaction } from "../simulated-transaction"

type RedeemClFarmLiquidityFromVaultProps = {
  chainId: number
  config: Config
  vaultAddress: Address
  amount: bigint
  account: Address
  functionName: "withdraw" | "withdrawAll"
  alm: ClFarmAlmType
}

/**
 * Fertilizer, Gamma & Steer use the generic redeem from vault function.
 * This should be compatible with only ELITE products such as ELMA
 * @internal
 * @returns
 */
export const redeemClFarmLiquidityFromVault = async ({
  chainId,
  config,
  vaultAddress,
  amount,
  account,
  functionName = "withdraw",
  alm,
}: RedeemClFarmLiquidityFromVaultProps): Promise<TransactionReturnType> => {
  try {
    const args = []
    let abi = undefined
    switch (alm) {
      case "Fertilizer":
        args.push(amount, 1, 1)
        abi = [
          {
            inputs: [
              { internalType: "uint256", name: "_shr", type: "uint256" },
              { internalType: "uint256", name: "_m0", type: "uint256" },
              { internalType: "uint256", name: "_m1", type: "uint256" },
            ],
            name: "withdraw",
            outputs: [
              { internalType: "uint256", name: "_us0", type: "uint256" },
              { internalType: "uint256", name: "_us1", type: "uint256" },
            ],
            stateMutability: "nonpayable",
            type: "function",
          },
        ] as const
        break
      case "Steer":
        args.push(amount, 1, 1, account)
        abi = [
          {
            inputs: [
              { internalType: "uint256", name: "shares", type: "uint256" },
              { internalType: "uint256", name: "amount0Min", type: "uint256" },
              { internalType: "uint256", name: "amount0Min1", type: "uint256" },
              { internalType: "address", name: "to", type: "address" },
            ],
            name: "withdraw",
            outputs: [
              { internalType: "uint256", name: "amount0", type: "uint256" },
              { internalType: "uint256", name: "amount1", type: "uint256" },
            ],
            stateMutability: "nonpayable",
            type: "function",
          },
        ] as const
        break
      case "Gamma":
        args.push(amount, account, account, [0, 0, 0, 0])
        abi = [
          {
            inputs: [
              { internalType: "uint256", name: "shares", type: "uint256" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "address", name: "from", type: "address" },
              { internalType: "uint256[4]", name: "minAmounts", type: "uint256[4]" },
            ],
            name: "withdraw",
            outputs: [
              { internalType: "uint256", name: "amount0", type: "uint256" },
              { internalType: "uint256", name: "amount1", type: "uint256" },
            ],
            stateMutability: "nonpayable",
            type: "function",
          },
        ] as const
        break
    }
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: abi as Abi,
        account,
        address: vaultAddress,
        args,
        chainId,
        functionName,
      },
    })
    return result
  } catch (error: any) {
    console.error("redeemClFarmLiquidityFromVault", error)
    return { success: false, error: error.message, code: error.code }
  }
}
